import { Holding, Watchlist, WatchlistSymbol } from './entities';

const toHoldingArray = (holding: Holding | Holding[] | undefined): Holding[] =>
  Array.isArray(holding) ? holding : holding ? [holding] : [];

// Merges all watchlists into a synthetic "Overview" watchlist, combining the
// holdings of a symbol held in more than one watchlist. Must never write to the
// WatchlistSymbol objects owned by WatchlistStore — they are cached across runs,
// so any mutation here compounds on every regeneration.
export const generateOverviewWatchlist = (watchlists: Watchlist[]): Watchlist | null => {
  if (watchlists.length < 2) return null;

  const overviewSymbols = watchlists
    .flatMap(watchlist => watchlist.symbols)
    .reduce((acc: Record<string, WatchlistSymbol>, symbol) => {
      const existing = acc[symbol.symbol];
      if (existing) {
        if (!symbol.holding) return acc;

        const mergedHoldings = [...toHoldingArray(existing.holding), ...toHoldingArray(symbol.holding)];
        acc[symbol.symbol] = {
          ...existing,
          holding: mergedHoldings.length === 1 ? mergedHoldings[0] : mergedHoldings,
        };
      } else {
        acc[symbol.symbol] = { ...symbol };
      }
      return acc;
    }, {});

  return {
    emailSummary: false,
    name: 'Overview',
    realtimeBZ: false,
    realtimePR: false,
    realtimeSEC: false,
    sound: '',
    symbols: Object.values(overviewSymbols),
    watchlistId: 'overview',
  };
};
